import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import auth from './reducers/auth';
import common from './reducers/common';
import application from './reducers/application';
import home from './reducers/home';
import trips from './reducers/trips';
import profile from './reducers/profile';
import settings from './reducers/settings';
import tables from './reducers/tables';
import sites from './reducers/sites';
import templates from './reducers/templates';
import data from './reducers/data';
import users from './reducers/users';
import cache from './reducers/cache';

export default combineReducers({
  auth,
  common,
  application,
  home,
  trips,
  profile,
  settings,
  tables,
  sites,
  templates,
  data,
  users,
  cache,
  router: routerReducer
});
